import { ChangeDetectorRef, Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { ScopePaginatedOverviewActions } from '@app/features/scope-overview/store/actions/scope-paginated-overview.actions'
import { HeaderStyleService, HIDE_HEADER } from '@app/shared/services/header-style.service'
import { Store } from '@ngrx/store'

@Injectable({ providedIn: 'root' })
export class NavigationService {
  constructor(
    private router: Router,
    private headerStyleService: HeaderStyleService,
    private store$: Store
  ) {}

  subscribeToNavigationMessages(cdr?: ChangeDetectorRef) {
    window.addEventListener('message', (event) => {
      this.navigateByAction(event.data.action, event.data.id, cdr, event.data.additionalParams)
    })
  }

  navigateByAction(action: string, id: number, cdr?: ChangeDetectorRef, additionalParams?: Record<string, any>) {
    switch (action) {
      case 'goToScopes':
        this.router.navigateByUrl('/scopes')
        break
      case 'goToScope':
        this.router.navigateByUrl(`/scopes/scope-overview/${id}`)
        if (additionalParams?.deliverableId) {
          this.store$.dispatch(
            ScopePaginatedOverviewActions.getScopeDeliverable({
              scopeId: id,
              deliverableId: additionalParams.deliverableId,
            })
          )
        }
        break
      case 'goToScopeByRole':
        this.router.navigateByUrl(`/scopes/scope-by-role-overview/${id}`)
        break
      case 'goToFolders':
        this.router.navigate(['/scopes'], { queryParams: { tab: 'folders' } })
        break
      case 'goToFolder':
        this.router.navigateByUrl(`/scopes/folder-overview/${id}`)
        break
      case 'goToRetainedTeam':
        this.headerStyleService.setHeaderClass(HIDE_HEADER)
        cdr.markForCheck()
        break
      case 'goOutRetainedTeam':
        this.headerStyleService.setHeaderClass(null)
        cdr.markForCheck()
        break
    }
  }
}
